/**
 * Copyright (c) 2019-2021 2022 AIGIA All Rights Reserved.
 */

"use strict";

import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {FloatingComponent} from "../floating/floating.component";

import {environment} from '../../../../environments/environment';
import {TranslateService} from "@ngx-translate/core";

/**
 * todo
 */
@Component({
	selector: "aigia-images",
	templateUrl: "./images.component.html",
	styleUrls: ["../floating/floating.component.css", "./images.component.css"],
})

export class ImagesComponent extends FloatingComponent implements OnInit {

	@Input() public locked: boolean = false;
	@Input() public style: any = {};
	@Input() public size: number[] = [];

	public title: string = "Images";
	public endPoint: string;

	public shotphases: any[] = [
		{name: "前傾ライン", value: "p1.svg"},
		{name: "センターポジション", value: "p2.svg"},
		{name: "センターライン", value: "p3.svg"},
		{name: "（ライト・レフト）ライン", value: "p4.svg"},
		{name: "ネックポジション", value: "p5.svg"},
		{name: "膝の角度", value: "p6.svg"},
	]

	public progress = false;

	@Output() public progrssChange = new EventEmitter<boolean>();

	/**
	 * todo
	 */
	constructor(
		public translate: TranslateService,
	) {
		super();
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.endPoint = environment.endPoint;
	}

	/**
	 * @returns none
	 */
	public initLayout(): void {
	}

	/**
	 * @returns none
	 */
	public phaseToImage(phase: any): string {
		return this.endPoint + "/images/" + phase.value;
	}

}
